import { RosterMember } from '@/model';
import {
  GetRosterMemberByIdResponse,
  GetRosterMemberItemResponse,
  GetRosterMemberResponse,
  PostRosterMemberResponse,
  PutRosterMemberResponse,
  PutRosterMemberStatisticsResponse,
} from '@/services/response/roster-member';

export class RosterMemberConverter {
  static toDomainFromGetItemResponse(response: GetRosterMemberItemResponse): RosterMember {
    return {
      uuid: response.uuid,
      group_uuid: response.group_uuid,
      group_name: response.group_name,
      type: response.type,
      name: response.name,
      role_label: response.role_label,
      picture: response.picture,
      hyperlink: response.hyperlink,
      shirt_number: response.shirt_number,
      birthdate: response.birthdate,
      age: response.age,
      nationality: response.nationality,
      height: response.height,
      contract_until: response.contract_until,
      stats: response.stats,
      sort_order: response.sort_order,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPaginatedResponse(response: GetRosterMemberResponse): RosterMember[] {
    return response.data.map(RosterMemberConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetRosterMemberByIdResponse): RosterMember {
    return RosterMemberConverter.toDomainFromGetItemResponse(response);
  }

  static toDomainFromPostResponse(response: PostRosterMemberResponse): RosterMember {
    return {
      uuid: response.uuid,
      type: response.type,
      name: response.name,
      role_label: response.role_label,
      picture: response.picture,
      sort_order: 0,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutResponse(response: PutRosterMemberResponse): RosterMember {
    return {
      uuid: response.uuid,
      type: response.type,
      name: response.name,
      role_label: response.role_label,
      picture: response.picture,
      sort_order: 0,
      created_at: response.created_at,
      updated_at: response.updated_at,
    };
  }

  static toDomainFromPutStatisticsResponse(response: PutRosterMemberStatisticsResponse): RosterMember {
    return RosterMemberConverter.toDomainFromGetItemResponse(response);
  }
}
